/** @format */

import {operatorsByType, orderFields} from 'frontier-admin/orders/filter_builder/fields';
import {SelectItem, Select} from '@/components/ui/select';
import {Button} from '@/components/ui/button';
import {Input} from '@/components/ui/input';
import {X} from 'lucide-react';
import React from 'react';

export const RenderConditionSingle = props => {
    const {condition, removeItem, updateItem} = props;

    const field = orderFields.find(f => f.field === condition.field);
    if (!field) {
        return (
            <div>
                Invalid field: {condition.field}{' '}
                <Button variant="incognito" size="xs" onClick={() => removeItem(condition.id)}>
                    <X className="tw-text-danger" size="24" />
                </Button>
            </div>
        );
    }

    return (
        <div
            key={condition.id}
            className="tw-flex tw-items-center tw-gap-2 tw-my-2 tw-bg-white tw-p-2 tw-rounded-lg tw-shadow-sm">
            <Select
                value={condition.field}
                onChangeValue={value => {
                    const newField = orderFields.find(f => f.field === value);
                    updateItem(condition.id, {
                        field: value,
                        operator: operatorsByType[newField.type][0],
                        value: ''
                    });
                }}>
                {orderFields.map(field => (
                    <SelectItem key={field.field} value={field.field}>
                        {field.label}
                    </SelectItem>
                ))}
            </Select>
            <Select
                value={condition.operator}
                onChangeValue={value => updateItem(condition.id, {operator: value})}>
                {field &&
                    operatorsByType[field.type].map(op => (
                        <SelectItem key={op} value={op}>
                            {op === '=='
                                ? 'equals'
                                : op === '!='
                                ? 'does not equal'
                                : op === '>'
                                ? 'greater than'
                                : op === '<'
                                ? 'less than'
                                : op === '>='
                                ? 'greater than or equal to'
                                : op === '<='
                                ? 'less than or equal to'
                                : op}
                        </SelectItem>
                    ))}
            </Select>
            {field?.type === 'list' ? (
                <Select
                    value={condition.value}
                    onChangeValue={value => updateItem(condition.id, {value})}>
                    {field.listOptions?.map(option => (
                        <SelectItem key={option.id} value={option.id}>
                            {option.label}
                        </SelectItem>
                    ))}
                </Select>
            ) : field?.type === 'boolean' ? (
                <Select
                    value={condition.value.toString()}
                    onChangeValue={value => updateItem(condition.id, {value: value === 'true'})}>
                    <SelectItem value="true">True</SelectItem>
                    <SelectItem value="false">False</SelectItem>
                </Select>
            ) : (
                <Input
                    data-dom-identifier="filter-number-input"
                    data-last-updated={condition.lastUpdated}
                    type={field?.type === 'number' ? 'number' : 'text'}
                    value={condition.value.toString()}
                    onChange={e => {
                        updateItem(condition.id, {
                            value:
                                field?.type === 'number' ? Number(e.target.value) : e.target.value,
                            lastUpdated: Date.now()
                        });
                    }}
                    className="tw-w-40"
                />
            )}
            <Button variant="ghost" size="sm" onClick={() => removeItem(condition.id)}>
                <X className="tw-text-danger" size="18" />
            </Button>
        </div>
    );
};
